import { Link } from "react-router-dom";

import logo from "../assets/logo-cpuc.png";

export default function Footer() {
  return (
    <footer className="site-footer pt-5 pb-4 mt-5">
      <div className="container">
        <div className="row gy-4">
          <div className="col-12 col-lg-3">
            <Link to="/" className="logo-badge mb-2">
              <img
                src={logo}
                alt="CPUc Solutions Technologiques"
                className="logo-img"
              />
            </Link>
            <p className="mb-0">
              Solutions technologiques pour cliniques et PME. Une informatique
              fiable, sans compromis.
            </p>
          </div>

          <div className="col-6 col-lg-2">
            <h6>Navigation</h6>
            <ul className="list-unstyled d-flex flex-column gap-2 mt-3">
              <li><Link to="/">Accueil</Link></li>
              <li><Link to="/services">Nos services</Link></li>
              <li><Link to="/technologies">Nos technologies</Link></li>
              <li><Link to="/support">Support</Link></li>
            </ul>
          </div>

          <div className="col-6 col-lg-2">
            <h6>Téléphonie</h6>
            <ul className="list-unstyled d-flex flex-column gap-2 mt-3">
              <li><Link to="/telephonie-ip">Offre de service</Link></li>
              <li><Link to="/telephonie-ip/sms">Textos</Link></li>
              <li><Link to="/telephonie-ip/fax">Fax</Link></li>
              <li><Link to="/telephonie-ip/equipements">Équipements</Link></li>
            </ul>
          </div>

          <div className="col-6 col-lg-2">
            <h6>Entreprise</h6>
            <ul className="list-unstyled d-flex flex-column gap-2 mt-3">
              <li><Link to="/simplicite">Simplicité</Link></li>
              <li><Link to="/a-propos">À propos</Link></li>
              <li><Link to="/politique-confidentialite">Politique de confidentialité</Link></li>
            </ul>
          </div>

          <div className="col-12 col-lg-3">
            <h6>Coordonnées</h6>
            <ul className="list-unstyled d-flex flex-column gap-2 mt-3">
              <li><Link to="/contact">Formulaire de contact</Link></li>
              <li>
                <a href="mailto:info@cpucsolutions.com">
                  info@cpucsolutions.com
                </a>
              </li>
              <li>
                <a href="tel:4184767088">(418) 476-7088</a>
              </li>
              <li>
                <a
                  href="https://www.facebook.com/profile.php?id=61555689801537"
                  target="_blank"
                  rel="noreferrer"
                >
                  Suivez-nous sur Facebook
                </a>
              </li>
            </ul>
          </div>
        </div>

        <hr className="border-secondary my-4" />

        <div className="d-flex flex-wrap justify-content-between align-items-center gap-2">
          <p className="small mb-0">
            © {new Date().getFullYear()} CPUc Solutions Technologiques. Tous droits réservés.
          </p>
          <Link
            to="/politique-confidentialite"
            className="small text-decoration-none text-secondary"
          >
            Politique de confidentialité
          </Link>
        </div>
      </div>
    </footer>
  );
}